import {
  GET_FILTER_DATA_REQUEST,
  GET_FILTER_DATA_SUCCESS,
  GET_FILTER_DATA_FAILURE,
  SET_SIDEBAR_FILTERS,
  RESET_SIDEBAR_FILTERS,
} from "../types/filterTypes";

interface SidebarFilterState {
  filterData: any;
  loading: boolean;
  error: any;
  selectedFilters: {
    fuel_type?: string;
    price?: any;
    [key: string]: any;
  };
}

const initialState: SidebarFilterState = {
  filterData: null,
  loading: false,
  error: null,
  selectedFilters: {
    fuel_type: "",
    price: "",
  },
};

export const sidebarFilterReducer = (
  state = initialState,
  action: any
): SidebarFilterState => {
  switch (action.type) {
    case GET_FILTER_DATA_REQUEST:
      return { ...state, loading: true };

    case GET_FILTER_DATA_SUCCESS:
      return { ...state, loading: false, filterData: action.payload.data };

    case GET_FILTER_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case SET_SIDEBAR_FILTERS:
      return { ...state, selectedFilters: action.payload };

    case RESET_SIDEBAR_FILTERS:
      return { ...state, selectedFilters: {} };

    default:
      return state;
  }
};
